interface ListOption {
  value: string;
  label: string;
}

let options: ListOption[] = [];

export const setListOptions = (v: ListOption[]): void => {
  options = v;
};

export const getListOptions = (): readonly ListOption[] => options;
